export default {
  namespaced: true,
  state: {
    extra: null,
  },
  mutations: {
    SET_EXTRA(state, payload) {
      state.extra = payload;
    }
  },
}



// WEBPACK FOOTER //
// ./src/stores/extras-modal.store.js